module.exports = __webpack_public_path__ + "img/财商@2x.346c55a8.png";